import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE } from '../../../../constants/Constant';
import PayrollService from '../../../../services/PayrollService';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import PayrollLiabilityGrid from './PayrollLiabilityGrid';
export default class PayrollLiabilityReport extends Component{
    constructor(props){
        super(props)
        this.state = {
            timePeriod: {
                toggle: false,
                startDate: moment().startOf('month'),
                endDate: moment().endOf("month"),
                defaultDate: false,
                hasError: false
            },
            showReport:false
        }
    }
    generate = false;
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    getTimePeriod () {
        const dateFormat = TenantService.get(TENANT.DATE_FORMAT);
        const timePeriod = this.state.timePeriod
        return timePeriod.startDate && timePeriod.endDate ? `${moment(timePeriod.startDate).format(dateFormat)} - ${moment(timePeriod.endDate).format(dateFormat)}` : '';
    }
    export(){
        this.setState({...this.state})
       
        if(this.state.timePeriod.hasError) {
            return;
        }
        ReportService.apiConfig = {
            format: 'XLSX',
            fromDate: moment(this.state.timePeriod.startDate).format('YYYY-MM-DD'),
            toDate: moment(this.state.timePeriod.endDate).format('YYYY-MM-DD')
            
            
        }
        ReportService.exportLiabilityReport().then(
            (response) => {
                
                saveAs(response, `Payroll_Liability_Report_${this.getTimePeriod()}.xlsx`);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("No Record to export", TOAST_TYPE.FAILURE);
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="Payroll Liability Report" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="Generate Payroll Liability Report" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex ">
                        <div className="p-h-l" style={{ width: "22%", minWidth:"200px" }}>
                            <div >
                                <div className="row">
                                    <DKInput
                                        title={"Time Period"}
                                        type={INPUT_TYPE.TEXT}
                                        value={this.getTimePeriod()}
                                        required={true}
                                        readOnly={true}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    />
                                    <DKIcon
                                        className={`mr-s cursor-hand z-index-1 mt-xl pt-xs`}
                                        style={{
                                            marginLeft: "-30px",
                                            filter: "contrast(0.5)"

                                        }}
                                        src={date_range}
                                        onClick={() => {
                                            this.setState({
                                                timePeriod: {
                                                    toggle: true,
                                                    startDate: this.state.timePeriod.startDate,
                                                    endDate: this.state.timePeriod.endDate,
                                                    defaultDate: true,
                                                    hasError: false
                                                }
                                            })
                                        }}
                                    />
                                    {this.state.timePeriod.toggle && <DKCalendar
                                        className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                        style={{ top: 90, width: 65, "z-index": "1" }}
                                        isDateRange={true}
                                        startDate={this.state.timePeriod.startDate ? new Date(this.state.timePeriod.startDate) : new Date()}
                                        endDate={this.state.timePeriod.endDate ? new Date(this.state.timePeriod.endDate) : new Date()}
                                        onClose={()=>{
                                            if(moment(this.state.timePeriod.startDate).diff(this.state.timePeriod.endDate) <= 0 || this.state.timePeriod.endDate == null) {
                                                this.setState({
                                                    timePeriod:{
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: false
                                                    }
                                                });
                                            } else {
                                                this.setState({
                                                    timePeriod: {
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: true,
                                                        errorMsg: "End date should not be less than Start date"
                                                    }
                                                });
                                            }
                                        }}
                                        onSelectDate={(start, end) => {
                                            if(start && end) {
                                                let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                                                let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                                                if(moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                                    this.setState({
                                                        timePeriod:{
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: false
                                                        }
                                                    });
                                                } else {
                                                    this.setState({
                                                        timePeriod: {
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: true,
                                                            errorMsg: "End date should not be less than Start date"
                                                        }
                                                    })
                                                }
                                            }
                                        }}
                                    />}
                                </div>
                                {this.state.timePeriod.hasError && <DKLabel
                                    className="mt-xs text-red"

                                    text={this.state.timePeriod.errorMsg}
                                />}
                            </div>
                            
                        </div>
                        
                        <div className="mb-xs ml-l" style={{marginTop: '25px'}}>
                                <DKButton
                                title="Generate Report"
                                // icon={DKIcons.white.ic_export}
                                className="bg-app text-white"
                                onClick={()=>{
                                    if(!this.state.timePeriod.hasError) {
                                        this.generate = !this.generate
                                        this.setState({
                                            ...this.state,
                                            showReport:true
                                        })
                                    }
                                }}
                                />
                            </div>
                        <div className="mb-xs mr-l justify-content-end" style={{marginTop: '30px', marginLeft:'auto'}}>
                            <DKButton
                            title="Export"
                            icon={DKIcons.white.ic_export}
                            className="bg-app text-white"
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
                {this.state.showReport && 
                <PayrollLiabilityGrid 
                filter={
                    {
                        from: moment(this.state.timePeriod.startDate).format('YYYY-MM-DD'),
                        to: moment(this.state.timePeriod.endDate).format('YYYY-MM-DD')
                    }
                }
                generate={this.generate}
                />}
            </div>
        )
    }
}